<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-field :class="[{ 'md-error': errors.has('WIFI_SSID') }]">
        <label>SSID</label>
        <md-input
          v-model="wifi.SSID"
          data-vv-name="WIFI_SSID"
          type="text"
          name="WIFI_SSID"
          v-validate="modelValidations.SSID"
          :disabled="!selectedDevice.owner"
          :maxlength="modelValidations.SSID.max"
        ></md-input>
        <slide-y-down-transition>
          <md-icon class="error" v-show="errors.has('WIFI_SSID')">close</md-icon>
        </slide-y-down-transition>
      </md-field>

      <md-field :class="[{ 'md-error': errors.has('WIFI_SEC') }]">
        <label for="channels">{{$lang.inputs.security}}</label>
        <md-select
          v-model="wifi.security"
          name="WIFI_SEC"
          data-vv-name="WIFI_SEC"
          v-validate="modelValidations.required"
          :disabled="!selectedDevice.owner"
        >
          <md-option value="0">{{$lang.general.none}}</md-option>
          <md-option value="1">WPA2 PSK</md-option>
        </md-select>
      </md-field>

      <md-field v-if="wifi.security == 1" :class="[{ 'md-error': errors.has('WIFI_PASS') }]">
        <label>{{$lang.general.password}}</label>
        <md-input
          v-model="wifi.password"
          data-vv-name="WIFI_PASS"
          type="password"
          name="WIFI_PASS"
          v-validate="modelValidations.PASS"
          :maxlength="modelValidations.PASS.max"
          :disabled="!selectedDevice.owner"
        ></md-input>
        <slide-y-down-transition>
          <md-icon class="error" v-show="errors.has('WIFI_PASS')">close</md-icon>
        </slide-y-down-transition>
      </md-field>

      <md-field :class="[{ 'md-error': errors.has('WIFI_DHCP') }]">
        <label for="channels">{{$lang.inputs.IP_settings}}</label>
        <md-select
          v-model="wifi.DHCP"
          name="WIFI_DHCP"
          data-vv-name="WIFI_DHCP"
          v-validate="modelValidations.required"
          :disabled="!selectedDevice.owner"
        >
          <md-option value="1">DHCP</md-option>
          <md-option value="0">{{$lang.general.static}}</md-option>
        </md-select>
      </md-field>

      <slide-y-down-transition>
        <div class="md-layout" v-if="wifi.DHCP == 0">
          <div class="md-layout-item md-size-50 md-xsmall-size-100">
            <md-field :class="[{ 'md-error': errors.has('WIFI_IP') }]">
              <label>{{$lang.inputs.IP_address}}</label>
              <md-input
                v-model="wifi.IP"
                data-vv-name="WIFI_IP"
                type="text"
                name="WIFI_IP"
                v-validate="modelValidations.address"
                :disabled="!selectedDevice.owner"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('WIFI_IP')">close</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>

          <div class="md-layout-item md-size-50 md-xsmall-size-100">
            <md-field :class="[{ 'md-error': errors.has('WIFI_MASK') }]">
              <label>{{$lang.inputs.network_mask}}</label>
              <md-input
                v-model="wifi.MASK"
                data-vv-name="WIFI_MASK"
                type="text"
                name="WIFI_MASK"
                v-validate="modelValidations.address"
                :disabled="!selectedDevice.owner"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('WIFI_MASK')">close</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>

          <div class="md-layout-item md-size-50 md-xsmall-size-100">
            <md-field :class="[{ 'md-error': errors.has('WIFI_GW') }]">
              <label>{{$lang.inputs.gateway}}</label>
              <md-input
                v-model="wifi.GW"
                data-vv-name="WIFI_GW"
                type="text"
                name="WIFI_GW"
                v-validate="modelValidations.address"
                :disabled="!selectedDevice.owner"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('WIFI_GW')">close</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>

          <div class="md-layout-item md-size-50 md-xsmall-size-100">
            <md-field :class="[{ 'md-error': errors.has('WIFI_DNS') }]">
              <label>DNS server</label>
              <md-input
                v-model="wifi.DNS"
                data-vv-name="WIFI_DNS"
                type="text"
                name="WIFI_DNS"
                v-validate="modelValidations.address"
                :disabled="!selectedDevice.owner"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('WIFI_DNS')">close</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>
        </div>
      </slide-y-down-transition>

      <md-checkbox class="md-primary" v-model="auto_reboot">{{$lang.keys.auto_restart}}</md-checkbox>

      <md-card-actions md-alignment="right">
        <md-button
          :class="{ 'md-success': selectedDevice.owner }"
          :disabled="!selectedDevice.owner"
          @click="saveData"
        >{{$lang.keys.save}}</md-button>
      </md-card-actions>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import axios from "axios";
import snackBar from "@/components/SnackBar";
import { SlideYDownTransition } from "vue2-transitions";
import { getUserToken, getSelectedDeviceToken } from "@/storage/memoryStorage";
import Swal from "sweetalert2";

export default {
  components: {
    "snack-bar": snackBar,
    SlideYDownTransition
  },
  props: {
    wifi: {
      type: Object
    }
  },
  data() {
    return {
      modelValidations: {
        required: {
          required: true
        },
        SSID: {
          required: true,
          min: 3,
          max: 32
        },
        PASS: {
          required: false,
          min: 8,
          max: 32
        },
        address: {
          required: true,
          min: 7,
          max: 15
        }
      },
      auto_reboot: true
    };
  },
  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    }
  },

  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          let dataToSend = {
            ssid: btoa(this.wifi.SSID),
            dhcp: this.wifi.DHCP,
            security: this.wifi.security
          };

          if (this.wifi.security == 1) {
            dataToSend.password = btoa(this.wifi.password);
          }

          if (this.wifi.DHCP == 0) {
            dataToSend.ip = this.wifi.IP;
            dataToSend.gw = this.wifi.GW;
            dataToSend.mask = this.wifi.MASK;
            dataToSend.dns = this.wifi.DNS;
          }

          axios({
            method: "POST",
            url: this.$ENDPOINTS.API_W + "/devices/config",
            data: {
              device_token: getSelectedDeviceToken(this.selectedDevice.mac),
              user_token: getUserToken(),
              wifi: dataToSend,
              auto_reboot: this.auto_reboot
            },
            withCredentials: true
          })
            .then(response => {
              Swal.fire({
                title: this.$lang.messages.success,
                text: this.$lang.messages.settings_successfully_saved,
                type: "success",
                confirmButtonClass: "md-button md-success",
                confirmButtonText: this.$lang.keys.close,
                buttonsStyling: false,
                timer: 2000
                // onClose: () => {
                //   this.$router.push({
                //     path: handleRedirect()
                //   });
                // }
              });
            })
            .catch(error => {
              if (error.response.data.code == 604) {
                Swal.fire({
                  title: this.$lang.messages.error,
                  text: this.$lang.messages.device_not_responding_or_offline,
                  type: "error",
                  confirmButtonClass: "md-button md-warning",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false
                });
              } else {
                Swal.fire({
                  title: this.$lang.messages.error,
                  text: this.$lang.messages.api_communication_error,
                  type: "error",
                  confirmButtonClass: "md-button md-warning",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false
                });
              }
            });
        }
      });
    },

    loadData() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/devices/config",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac)
        },
        withCredentials: true
      })
        .then(response => {
          this.wifi.ssid = response.data.data.WIFI.SSID;
          this.wifi.dhcp = String(response.data.data.WIFI.DHCP);
          this.wifi.ip = response.data.data.WIFI.IP;
          this.wifi.mask = response.data.data.WIFI.MASK;
          this.wifi.gw = response.data.data.WIFI.GW;
        })
        .catch(error => {
          if (error.response.data.code == 604) {
            this.$refs.snackbar.notify("Device is offline");
          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    }
  }
};
</script>
